import { gqlCountryEnum as COUNTRY } from '@minecraft.graphql-types';
import { getEnvironment } from '@minecraft.environment';
import { appConfig as globalAppConfig } from '@minecraft.app-config';

const appConfig: Record<string, any> = {};
const env = getEnvironment();

appConfig.companyName = 'Casting Networks';
appConfig.appName = 'Representatives';
appConfig.cdnRoot = env.CDN_URL;
appConfig.svgRoot = `${appConfig.cdnRoot}/images/icons/b21/`;
appConfig.defaultCountryCode = COUNTRY.US;
appConfig.countryAllKey = globalAppConfig.allCountriesCode;
appConfig.defaultLanguageCode = 'en';
appConfig.defaultMeasurementUnit = 'imperial'; // vs metric
appConfig.delayRedirect = 2000; // 2 seconds
appConfig.defaultURL = '/projects';

appConfig.username = 'Dabeer Nastar';
appConfig.placeholderImgRoot = '//via.placeholder.com/';
appConfig.pageSizes = [25, 50, 100, 250, 500];
appConfig.paginationPageLimit = appConfig.pageSizes && appConfig.pageSizes.length ? appConfig.pageSizes[0] : 100;
appConfig.profileSearchPageSizes = [25, 50, 100];
appConfig.profileSearchPageSize = 100;
appConfig.projectSearchPageSizes = [25, 50, 100];
appConfig.projectSearchPageSize = 50;

appConfig.noOrgsUlaUrl = 'no-org';

appConfig.initialPage = 1;
appConfig.pageLimit = 100;

export default appConfig;
